var _defs, _mask;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoRedOnWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    id: "svg16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "icon/file/attachment_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M13,17 L11,17 L11,11 L13,11 L13,17 Z M13,9 L11,9 L11,7 L13,7 L13,9 Z",
    id: "path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Policy-Header---Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "policy_header-OP1-(email)",
    transform: "translate(-886.000000, -380.000000)",
    style: {
      fill: "#a50000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(440.000000, 184.000000)",
    style: {
      fill: "#a50000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 161.000000)",
    style: {
      fill: "#a50000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(444.000000, 33.000000)",
    style: {
      fill: "#a50000",
      fillOpacity: 1
    }
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "red"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    id: "use7"
  }))), /*#__PURE__*/React.createElement("use", {
    id: "icon/action/info_24px",
    fill: "#000000",
    xlinkHref: "#path-1",
    style: {
      fill: "#a50000",
      fillOpacity: 1
    }
  }))))), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 2.22992,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      fillOpacity: 1
    },
    id: "rect845",
    width: 2,
    height: 2,
    x: 9,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9,
    x: 9,
    height: 6,
    width: 2,
    id: "rect845-3",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.86233,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRedOnWhite);
export default __webpack_public_path__ + "static/media/info_red-on-white.7c8dbdafe92a0abe70bff34b8f1b808f.svg";
export { ForwardRef as ReactComponent };